import {LayoutTemplate} from 'lucide-react'
import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'
import {useI18n} from '@/i18n'
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from '@/components/ui/tooltip'
import {routes} from '@/lib/routes'

interface LayoutActiveIndicatorProps {
    useCaseKey: string
}

/**
 * Small admin-only indicator shown when a form layout is active.
 * Only visible to users with form-layouts:manage permission.
 * Links to the designer page for quick access.
 */
export function LayoutActiveIndicator({useCaseKey}: LayoutActiveIndicatorProps) {
    const {hasPermission} = useAuth()
    const i18n = useI18n()

    if (!hasPermission(permissions.formLayouts.manage)) return null

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <a
                        data-testid="layout-active-indicator"
                        href={routes.schema.formLayouts.detail(useCaseKey)}
                        className="inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium text-primary hover:bg-primary/20 transition-colors"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <LayoutTemplate className="h-3 w-3" />
                        {i18n.formLayouts.layoutActiveIndicator}
                    </a>
                </TooltipTrigger>
                <TooltipContent>{i18n.formLayouts.layoutActiveIndicatorTooltip}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
